export const conditionColors = (condition) => {
  switch (condition) {
    case '4':
    case '3':
      return 'text-fpx-red'
    case '2':
      return 'text-yellow'
    default:
      return 'text-grey-100'
  }
}

export const isMaxRefloored = (auditUnit) => {
  return auditUnit?.attributes['current-floor'] >= auditUnit?.attributes['maximum-refloors'] + 1
}

export const canRefloor = (condition, auditUnit) => {
  if (isMaxRefloored(auditUnit)) {
    return '0'
  }

  switch (condition) {
    case '4':
    case '3':
      return '0'
    case '1':
      return '1'
    default:
      return auditUnit.attributes['can-refloor'] ? '1' : '0'
  }
}

export const getAuditUnitWarnings = (auditUnit) => {
  const warnings = []
  if (!auditUnit) return warnings

  const currentSold = auditUnit.attributes['current-sold'] ?? auditUnit.attributes.sold

  if (isMaxRefloored(auditUnit)) {
    warnings.push('MAX REFLOORS')
  } else if (!auditUnit.attributes['can-refloor']) {
    warnings.push('NO REFLOOR')
  }

  if (auditUnit.attributes['is-nsf']) {
    warnings.push('NSF')
  }
  if (auditUnit.attributes['is-repo']) {
    warnings.push('REPO')
  }
  if (auditUnit.attributes['sot-on']) {
    warnings.push('SOT')
  }

  switch (currentSold) {
    case '1':
      warnings.push('SOLD')
      break
    case '3':
      warnings.push('TEST DRIVE')
      break
    case '4':
      warnings.push('ARB')
      break
  }

  return warnings
}